window.addEventListener("DOMContentLoaded", () => {
    // パラメータから値を取得する
    let data = getFormValue();
    // 値を表示する
    for (let value in data) {
        setFormValue(value, data[value]);
    }
    // 送信ボタンがクリックされた時にフォームの送信を行う
    const formButton = document.getElementById("formButton");
    formButton.addEventListener("click", (event) => {
        contactSubmit(event);
    });
});

const getFormValue = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const lastName = urlParams.get("lastName");
    const firstName = urlParams.get("firstName");
    const kanaLastName = urlParams.get("kanaLastName");
    const kanaFirstName = urlParams.get("kanaFirstName");
    const postal = urlParams.get("postal");
    const address =
        urlParams.get("address1") +
        urlParams.get("address2") +
        urlParams.get("address3");
    const tel = urlParams.get("tel");
    const mail = urlParams.get("mail");
    const textarea = urlParams.get("textarea");

    let data = {
        lastName: lastName,
        firstName: firstName,
        kanaLastName: kanaLastName,
        kanaFirstName: kanaFirstName,
        postal: postal,
        address: address,
        tel: tel,
        mail: mail,
        textarea: textarea,
    };

    return data;
};

const setFormValue = (key, value) => {
    if (key) {
        document.getElementById(key).textContent = value;
    }
};

// 問い合わせフォーム送信
const contactSubmit = (e) => {
    e.preventDefault();
    //API GatewayのエンドポイントURL
    let url =
        "https://1t78601enl.execute-api.ap-northeast-1.amazonaws.com/default/tsumikiyaShopContactForm";

    let data = getFormValue();

    fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json; charset=utf-8" },
        body: JSON.stringify(data),
    })
        .then((response) => response.json())
        .then((data) => {
            console.log("Success:", data);
            window.location.href = "/pages/contact-thanks";
        })
        .catch((error) => {
            console.log(error);
            alert("送信に失敗しました。");
        });
};
